import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { initUploadInput } from 'reactApp/appHelpers/appHelpers';
import { setUploadFromAction } from 'reactApp/modules/upload/upload.module';
import { UploadIcon } from 'reactApp/ui/VKUIIcons';
import { sendGa } from 'reactApp/utils/ga';

import styles from '../EmptyFolder.css';
import { EItemType, gaSuffix } from '../EmptyFolder.types';

const getText = (isAlbum?: boolean) => {
    if (isAlbum) {
        return {
            title: 'Загрузить фото и видео',
            annotation: 'Вы также можете перетащить фото и видео для загрузки в этот альбом',
        };
    }

    return {
        title: 'Загрузить файлы',
        annotation: 'Вы также можете перетащить файлы для загрузки в эту папку',
    };
} 

export const useUpload = (isAlbum?: boolean) => {
    const dispatch = useDispatch();
    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => initUploadInput(inputRef.current), []);

    const Upload = useMemo(
        () => (
            <div className={styles.icon}>
                <input type="file" multiple className={styles.input} ref={inputRef} />
                <UploadIcon />
            </div>
        ),
        [inputRef]
    );
    
    const handleUpload = useCallback(() => {
        sendGa(gaSuffix, 'upload');
        dispatch(setUploadFromAction('empty-folder'));
    }, []);

    return useCallback(() => {
        return {
            ...getText(isAlbum),
            onClick: handleUpload,
            type: EItemType.UPLOAD,
            Icon: Upload,
        };
    }, [Upload, handleUpload, isAlbum]);
};

